export default __webpack_public_path__ + "static/media/PeggySign.7821f35b.jpg";